shvenergy.videos = (function ($) {
	"use strict";

	function init() {
		var videoElements = $("[data-video]");
        var embed;
        var bynderVideoUrl;
        var videoProvider;

		videoElements.each(function () {
			embed = $(this).data("videoembedurl");
			bynderVideoUrl = $(this).data("videosourceurl");
			videoProvider = $(this).data("videotype");
			var trackingText = $(this).data("trackingtext") || '';
			var trackingCategory = $(this).data("trackingcategory") || '';
			var button = $(this).find(".video-play-button").length ?  $(this).find(".video-play-button") : $(this).find("[data-video-play-btn]");
			button.data("videoembedurl", embed);
			button.data("videosourceurl", bynderVideoUrl);
			button.data("videotype", videoProvider);

			button.on("click", function (e) {
				e.stopPropagation();
                var videoUrl = $(this).data("videoembedurl");
                var bynderVideoUrl = $(this).data("videosourceurl");
                var videoSourceProvider = $(this).data("videotype");
				var pageName = document.pageType == "Content page" ? document.title : document.pageType;

                if (videoSourceProvider == "Bynder") {
                    shvenergy.byndervideoplayer.playbyndervideo(bynderVideoUrl);
                }
                else {
                    shvenergy.videoplayer.playvideo(videoUrl);
                }  
				shvenergy.tracking.trackEvent(trackingCategory, "Play video", trackingText);

				let videoWithTeaserEl = e.target.closest('.video-with-teaser');

				if (videoWithTeaserEl) {
					let textEl = videoWithTeaserEl.querySelector('p'),
						text = textEl ? textEl.innerText : '';
					trackingText = trackingText + " " + text;
				}

				shvenergy.tracking.trackRawEventData({
					'event': 'clickVideo',
					'videoName': trackingText,
					'pagename': pageName
				});
			});
		});

		const config = {
			root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
			rootMargin: '0px',
			threshold: 0.5
		};
		const videos = document.querySelectorAll("[data-lazyloadiframe]");

		function observerCallback(entries, videoObserver) {
			entries.forEach((entry) => {
				console.log(entry);
				if (entry.isIntersecting) {
					console.log("JA");
					entry.target.src = entry.target.dataset.src;
					videoObserver.unobserve(entry.target);
				}
			});
		}

		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver(observerCallback, config);

			videos.forEach(video => {
				observer.observe(video);
			});
		} else {
			//Sorry IE, but you just don't have what it takes
			videos.forEach(video => {
				video.src = video.dataset.src;
			});
		}

		let youtubeIFrames = document.querySelectorAll('iframe.ytp-iframe'),
			iFrameIndex = 0;

		youtubeIFrames.forEach((iframe) => {
			iFrameIndex += 1;
			
			let iframeId = "ytp-" + iFrameIndex;
			iframe.id = iframeId;
		});

		setTimeout(() => {
			let videos = document.querySelectorAll('video'),
				pageName = document.pageType == "Content page" ? document.title : document.pageType;
			
			videos.forEach((video) => {
				video.addEventListener('click', (e) => {
					let target = e.target,
						figureEl = target.closest('figure.video-w-caption'),
						captionEl = figureEl.querySelector('figcaption'),
						trackingText = captionEl ? captionEl.innerText : "";

					shvenergy.tracking.trackRawEventData({
						'event': 'clickVideo',
						'videoName': trackingText,
						'pagename': pageName
					});
				});
			});
		},
		1000);

	}

	init();

})(jQuery);

function onYouTubeIframeAPIReady() {
	let youtubeIFrames = document.querySelectorAll('iframe.ytp-iframe');
	youtubeIFrames.forEach((iframe) => {
		let player,
			iframeId = iframe.id;

		player = new YT.Player(iframeId, {
			events: {
			'onStateChange': onPlayerStateChange
			}
		});

		function onPlayerStateChange(event) {
			const state = event.data;
			let container = event.target.getIframe().parentNode.parentNode,
				figcaption = container.querySelector('figcaption'),
				caption = figcaption ? figcaption.innerText : '',
				pageName = document.pageType == "Content page" ? document.title : document.pageType;

			if (state === 1 || state === 2) { // 1: playing, 2: paused
				shvenergy.tracking.trackRawEventData({
					'event': 'clickVideo',
					'videoName': caption,
					'pagename': pageName
				});
			}
		}
	});

}